var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from '@emotion/styled';
import Fab from '@mui/material/Fab';
var ButtonStyled = styled(Fab)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  padding: 0;\n\n  &:hover {\n    opacity: 0.8;\n    background-color: ", ";\n  }\n\n  svg {\n    color: #efefef;\n  }\n"], ["\n  background-color: ", ";\n  padding: 0;\n\n  &:hover {\n    opacity: 0.8;\n    background-color: ", ";\n  }\n\n  svg {\n    color: #efefef;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.action;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.action;
});
export var ButtonFab = function (props) {
    return <ButtonStyled data-testid="fab-button" size="medium" {...props}/>;
};
var templateObject_1;
